import Route from '@ember/routing/route';
import { service } from '@ember/service';
import { instrumentRoutePerformance } from '@sentry/ember';
import StoreService from 'scaleflow/services/store';

class SettingsRolesListCreateRoute extends Route {
  @service declare store: StoreService;

  model() {
    return this.store.createRecord('role', {});
  }
}

export default instrumentRoutePerformance(SettingsRolesListCreateRoute);
